// extracted by mini-css-extract-plugin
module.exports = {"component":"notifications-Notifications__component--yXrN-"};